import { SkeletonChip } from "@health/ui";

/**
 * Loading skeleton shared by `ChipsWidget` and `ChipGroupWidget` — a single
 * chip-shaped placeholder matching the real `Chip`'s height + radius so the
 * pre-mount → mount → first-streamed-chip handoff doesn't shift the layout.
 *
 * Option/question count is unknown until the widget hydrates, so we render
 * one chip regardless of how many questions or options will eventually
 * appear.
 */
export function ChipsWidgetSkeleton() {
  return <SkeletonChip />;
}

/** Same shape as {@link ChipsWidgetSkeleton} — one chip for the first chip
 * of the first question. Re-exported as a distinct symbol so the registry
 * dispatch table reads naturally (`show_chip_group → ChipGroupWidgetSkeleton`).
 */
export const ChipGroupWidgetSkeleton = ChipsWidgetSkeleton;
